import { useLocation, useNavigate } from 'react-router-dom';
import { useUserPreferences } from '../context/UserPreferencesContext';
import useAiStatus from '../hooks/useAiStatus';

// Pages gated on a server-side capability rather than preference alone. Focusly
// AI needs an Anthropic API key on the deployment, so it is hidden entirely
// where there isn't one -- a preference toggle cannot conjure the backend.
export const CAPABILITY_GATED_PAGES = { '/ai': 'ai' };

export const TOGGLEABLE_PAGES = [
  { path: '/ai', name: 'Focusly AI', icon: '\u2728' },
  { path: '/focus', name: 'Focus', icon: '\uD83C\uDFAF' },
  { path: '/planner', name: 'Daily', icon: '\uD83D\uDCD3' },
  { path: '/board', name: 'Board', icon: '\uD83D\uDCCB' },
  { path: '/overdue', name: 'Overdue', icon: '\u26A0\uFE0F' },
  { path: '/unscheduled', name: 'Not Scheduled', icon: '\uD83D\uDCC5' },
  { path: '/completed', name: 'Completed', icon: '\u2705' },
];

const SETTINGS_PAGE = { path: '/settings', name: 'Settings', icon: '\u2699\uFE0F' };

export default function PageNavList({ onSelectPage }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { hiddenPages } = useUserPreferences();
  const { aiEnabled } = useAiStatus();

  const handleClick = (path) => {
    if (onSelectPage) onSelectPage();
    navigate(path);
  };

  const visiblePages = [
    ...TOGGLEABLE_PAGES.filter(
      (p) => !hiddenPages.includes(p.path) && (p.path !== '/ai' || aiEnabled)
    ),
    SETTINGS_PAGE,
  ];

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
        <strong>Main</strong>
      </div>
      <div className="p-2">
        {visiblePages.map((page) => {
          const isSelected = location.pathname === page.path;
          return (
            <div
              key={page.path}
              className={`d-flex align-items-center rounded px-2 py-1 ${isSelected ? 'bg-primary text-white' : 'hover-bg'}`}
              style={{ cursor: 'pointer' }}
              onClick={() => handleClick(page.path)}
            >
              <span className="me-2">{page.icon}</span>
              <span className="flex-grow-1 text-truncate">{page.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
